<template>
  <nuxt-link v-slot="scopeSlots" v-bind="attrs" :to="toPath" active-class="pointer-events-none">
    <slot :is-active="scopeSlots?.isActive"></slot>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { RouteLocation, RouteLocationRaw } from 'vue-router'

const localePath = useLocalePath()

const attrs = useAttrs()

const props = defineProps<{
  to?: string | RouteLocation | RouteLocationRaw
}>()

// nuxt-i18n 的 type 定義尚未更新，此處先讓 ts 忽略
const toPath = computed(() => (props.to ? localePath(props.to as RouteLocationRaw) : undefined))
</script>
